// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileMain_wrapper__qmq0Z"};